import "./style.css";

export default class LatestPublications {
  static selector = ".our-specialisms";

  constructor(block) {
    this.index = 0;
    this.x0 = null;
    this.x = 0;

    this.descriptions = block.querySelectorAll(
      ".our-specialisms__grid-item-description"
    );

    this.backgroundImages = block.querySelectorAll(
      ".our-specialisms__grid-item-image-wrapper"
    );
    this.setupBackgroundImages();

    let specialismsWrapper = document.querySelector(".our-specialisms");
    specialismsWrapper.addEventListener("click", this.onClick);
    specialismsWrapper.addEventListener("touchstart", this.onTouchStart);
    specialismsWrapper.addEventListener("touchmove", this.onTouchMove, {
      passive: false
    });
    specialismsWrapper.addEventListener("touchend", this.onTouchEnd);
    specialismsWrapper.addEventListener("mousedown", this.onTouchStart);
    specialismsWrapper.addEventListener("mousemove", this.onTouchMove, {
      passive: false
    });
    specialismsWrapper.addEventListener("mouseup", this.onTouchEnd);

    window.addEventListener("load", this.onResize);
  }

  setupBackgroundImages = () => {
    this.backgroundImages.forEach(backgroundImage => {
      const backgroundUrl = backgroundImage.dataset.large;
      let image = new Image();
      image.onload = () => {
        let backgroundLarge = backgroundImage.querySelector(
          ".our-specialisms__grid-item-image--large"
        );
        backgroundLarge.style.backgroundImage = "url('" + backgroundUrl + "')";
        backgroundLarge.classList.add(
          "our-specialisms__grid-item-image--large--loaded"
        );
      };
      image.src = backgroundUrl;
    });
  };

  clamp = (val, min = 0, max = 1) => Math.max(min, Math.min(max, val));

  ellipsizeTextBox = el => {
    if (el.ellipsizeWidth && el.ellipsizeWidth === el.offsetWidth) {
      return;
    }

    if (!el.originalWords) {
      el.originalWords = el.innerText.split(" ");
    } else {
      el.innerText = el.originalWords.join(" ");
    }

    el.ellipsizeWidth = el.offsetWidth;

    const wordArray = [...el.originalWords];
    while (el.scrollHeight > el.offsetHeight) {
      wordArray.pop();
      el.innerHTML = wordArray.join(" ") + "&hellip;";
    }
  };

  onTouchStart = e => {
    if (window.innerWidth > 1024) {
      return false;
    }

    this.dragging = false;
    this.x0 = (e.touches && e.touches[0] && e.touches[0].clientX) || e.clientX;
    this.firstClientX = this.x0;
    this.firstClientY =
      (e.touches && e.touches[0] && e.touches[0].clientY) || e.clientY;
  };

  onTouchMove = e => {
    if (window.innerWidth > 1024) {
      return false;
    }

    let x = (e.touches && e.touches[0] && e.touches[0].clientX) || e.clientX;
    let y = (e.touches && e.touches[0] && e.touches[0].clientY) || e.clientY;

    //prevent drag and scroll
    const minValue = 5; // threshold

    this.clientX = x - this.firstClientX;
    this.clientY = y - this.firstClientY;

    // Vertical scrolling does not work when you start swiping horizontally.
    if (Math.abs(this.clientX) > minValue && e.cancelable) {
      //do not scroll
      e.preventDefault();
    } else {
      //scroll
      return;
    }

    this.dragging = true;

    const index = this.index;
    const x0 = this.x0;
    const item = e.currentTarget.querySelector(".our-specialisms__grid-item");
    //const liMarginRight = window.innerWidth > tablet ? 25 : 15;
    const itemWidth = item.offsetWidth + 20;

    if (x0 === null) {
      return;
    }

    const wrapper = e.currentTarget.querySelector(".our-specialisms__grid");
    const value = x - x0 + index * itemWidth;
    wrapper.style.transform = "translateX(" + value + "px)";
    wrapper.style.transition = "none";

    if (Math.abs(e.clientX - x0) < 50) {
      //ul.classList.add('p-e--none');
    }

    this.x = x;
  };

  onTouchEnd = e => {
    if (window.innerWidth > 1024) {
      return false;
    }

    let index = this.index;
    const dX = this.x - this.x0;
    const wrapper = e.currentTarget.querySelector(".our-specialisms__grid");
    const item = e.currentTarget.querySelector(".our-specialisms__grid-item");
    const itemWidth = item.offsetWidth + 20;
    const itemsLength = e.currentTarget.querySelectorAll(
      ".our-specialisms__grid-item"
    ).length;

    index += Math.round(dX / itemWidth);
    index = this.clamp(index, -(itemsLength - 1), 0);

    this.x0 = null;

    //ul.classList.remove('p-e--none');

    this.updateIndex(index);
    wrapper.style.transition = null;
    wrapper.style.transform = "translateX(" + index * itemWidth + "px)";
  };

  updateCarousel = () => {
    const itemsLength = document.querySelectorAll(".our-specialisms__grid-item")
      .length;
    let wrapper = document.querySelector(".our-specialisms__grid");
    let item = document.querySelector(".our-specialisms__grid-item");
    const itemWidth = item.offsetWidth + 20;
    let index = this.index;

    if (window.innerWidth < 1025) {
      index = this.clamp(index, -(itemsLength - 1), 0);
      wrapper.style.transform = "translateX(" + index * itemWidth + "px)";
    }

    this.updateIndex(index);
  };

  updateIndex = value => {
    this.index = value;
    let numerator = document.querySelector(".our-specialisms__numerator span");
    numerator.innerText = Math.abs(value) + 1;
  };

  onResize = () => {
    this.descriptions.forEach(el => this.ellipsizeTextBox(el));
    this.updateCarousel();
  };

  onClick = e => {
    if (this.dragging) {
      e.preventDefault();
    }
  };
}
